<template>
  <div id="app">
    <wechat :id="currentId"/>
  </div>
</template>

<script>
import wechat from './components/wechat.vue'

export default {
  name: 'App',
  components: {
    wechat
  },
  data() {
    return {
      currentId: this.$route.query.id
    }
  },
  watch: {
    '$route.query.id': {
      handler(newId) {
        this.currentId = newId
      },
      immediate: true
    }
  },
  mounted() {
    this.$root.$on('update-title', (title) => {
      document.title = title || '聊天记录'
    })
    
    // 禁用右键菜单
    document.oncontextmenu = () => false
    
    // 禁用F12、Ctrl+Shift+I、Ctrl+Shift+J、Ctrl+Shift+C
    document.onkeydown = (e) => {
      if (
        e.key === 'F12' ||
        (e.ctrlKey && e.shiftKey && (e.key === 'I' || e.key === 'J' || e.key === 'C')) ||
        (e.ctrlKey && e.key === 's')
      ) {
        e.preventDefault()
        return false
      }
    }
  }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
